var _path, _path2, _path3, _line, _line2, _line3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3733 31.793H3.45982L2.5 35.9596H38.3331L37.3733 31.793Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2935 23.8757C24.1224 24.1517 26.713 24.9794 29.2 24.9794C31.687 24.9794 33.9667 24.0597 35.1065 23.3239C35.6039 23.1031 36.2464 22.4961 36.35 22.4961",
    stroke: "#FF8165",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5677 9.64564C30.2046 10.3098 31.8414 9.64564 31.8414 9.64564M31.8414 9.64564C31.8414 9.64564 34.4605 8.98146 34.4605 6.98892C34.4605 4.33221 33.151 3.33594 28.8951 3.33594C24.9666 3.33594 23.0023 4.46231 23.0023 6.98892C23.0023 8.84863 24.7483 9.75634 25.6213 9.97773V15.9553C25.6213 17.6158 23.3694 18.7093 22.6749 18.9442C21.6928 19.2762 20.3833 20.2725 20.3833 21.6009C20.3833 22.6636 20.3833 24.9218 20.3833 25.918C20.7107 27.1357 22.8059 29.571 28.5677 29.571C34.3295 29.571 36.4247 27.1357 36.7521 25.918V21.6009C36.7521 20.826 36.7521 19.6083 35.4426 18.9442C33.8657 18.1444 31.5141 17.6158 31.5141 16.2874C31.5141 15.2247 31.7433 11.5275 31.8414 9.64564Z",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.8063,
    y1: 14.202,
    x2: 20.1395,
    y2: 14.202,
    stroke: "#1552E8",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1515,
    y1: 16.8661,
    x2: 19.4847,
    y2: 16.8661,
    stroke: "#1552E8",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.49721,
    y1: 19.5223,
    x2: 15.5566,
    y2: 19.5223,
    stroke: "#1552E8",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3513 32.1146L38.3334 35.9608H1.66699L8.21457 10.9609H20.655",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.e0ad7ebf12721563bd0a52e1fd28113b.svg";
export { ForwardRef as ReactComponent };